import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails, getSubTaskStepList, updateStepStatusSuccess, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { USER_PERMISSIONS } from 'permission-library';
import { environment } from 'environment-configurations';
import * as i6 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { PaLoadComponent } from 'petition-analysis-library';
import moment from 'moment';
import * as i1$1 from 'authentication';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i7 from 'primeng/dynamicdialog';
import * as i8 from 'app-services-library';

class APIReviewPetition {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    postActionCode(visatype, taskId, stepId, payload) {
        return this.httpClient.post(`/${visatype}/task/${taskId}/step/${stepId}/update`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postNotifyReviewer(visatype, caseType, caseId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/notifyReviewer`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getReviewPetitiondocDraft(visatype, caseType, caseId, draft) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    postReviewPetitiondocDraft(visatype, caseType, caseId, draft) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    savePetionReviewerDetails(visatype, caseType, caseId, reviewerId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/reviewer/${reviewerId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getPetionReviewerDetails(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/reviewer`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getStatusAndResponse(stepTypeCode) {
        return this.httpClient.get(`/step/${stepTypeCode}/statusAndResponse`).pipe(map(response => {
            return response['data'];
        }));
    }
    getTask(visatype, taskId) {
        return this.httpClient.get(`/${visatype}/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getReviewersUser(companyId, permissionName) {
        return this.httpClient.get(`/company/${companyId}/employee?permissionName=${permissionName}`).pipe(map((response) => response.data));
    }
    generateAnalysis(petitionId) {
        return this.httpClient.post(`/analysis/petition/${petitionId}/All`, {}).pipe(map((response) => response));
    }
    getPetitionAnalysisStatus(petitionId) {
        return this.httpClient.get(`/analysis/petition/${petitionId}/status`).pipe(map((response) => response));
    }
}
APIReviewPetition.ɵfac = function APIReviewPetition_Factory(t) { return new (t || APIReviewPetition)(i0.ɵɵinject(i1.HttpClient)); };
APIReviewPetition.ɵprov = i0.ɵɵdefineInjectable({ token: APIReviewPetition, factory: APIReviewPetition.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIReviewPetition, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseReviewPetitionLibraryService {
    constructor(authenticationService, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, dialogService, appServicesLibraryService) {
        this.authenticationService = authenticationService;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.dialogService = dialogService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.reviewerInformation = {
            firstName: '',
            lastName: '',
            reviewerDesignation: '',
            id: null
        };
        this.review = {
            reviewCode: "",
            reviewNote: "",
            statusCode: "",
        };
        this.disabledControls = false;
        this.previousStepStatus = false;
        this.printPetitionBlock = false;
        this.draftGeneratedDate = '';
        this.disableSave = false;
        this.notifyReviewer = false;
        this.draftPDFPath = '';
    }
    loadInit() {
        let companyId = this.inputData.companyId;
        if (this.inputData.caseType == "I130") {
            companyId = this.inputData.attorneyId;
        }
        this.apiService.getReviewersUser(companyId, USER_PERMISSIONS.PETITION_REVIEWER)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.users = data;
            this.initReviewerDetails();
        });
        if (sessionStorage.getItem('wizardTID')) { //when Wizard is there
            // this.toggleControlsStatus();
            this.getReviewStatusList();
            this.getGenernatedPetition(true);
            this.getPetitionAnalysisStatus();
        }
        else {
            // Get Specific step details by passing step code
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data.stepReviewDetails) {
                    this.review.reviewCode = data.stepReviewDetails.stepReviewCode;
                    this.review.reviewNote = data.stepReviewDetails.stepReviewNote;
                }
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                this.toggleControlsStatus();
                this.getReviewStatusList();
                this.getGenernatedPetition(true);
                this.getPetitionAnalysisStatus();
            });
        }
        //IM-15088
        let previousStepId = this.inputData.stepId - 1;
        // Get Step list and get the actual previous step id rather than checking with stepId-1
        this.store.pipe(select(getSubTaskStepList)).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            if (data) {
                this.stepList = data;
                const currentStepIndex = this.stepList.findIndex((step) => step.id === this.inputData.stepId);
                if (currentStepIndex > 0) {
                    if (this.stepList[currentStepIndex - 1] && this.stepList[currentStepIndex - 1]['id'] && this.stepList[currentStepIndex - 1]['id'] !== previousStepId) {
                        previousStepId = this.stepList[currentStepIndex - 1]['id'];
                    }
                }
            }
        });
        // get previous step details by passing previous step code
        this.store.pipe(select(getStepDetails, { id: previousStepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
            this.previousStepStatus = data && data.stepStatusDetails && data.stepStatusDetails.stepStatusCode === 'COMPLETE' ? false : true;
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngAfterViewInit() {
        this.printReviewForm.valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (this.printReviewForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    generatePetitionAnalysis() {
        this.apiService.generateAnalysis(this.inputData.caseId).subscribe();
        const ref = this.dialogService.open(PaLoadComponent, {
            height: '480px',
            width: '620px',
            data: {
                inputData: this.inputData
            }
        });
        ref.onClose.subscribe((data) => {
            this.getPetitionAnalysisStatus();
        });
    }
    getPetitionAnalysisStatus() {
        this.apiService.getPetitionAnalysisStatus(this.inputData.caseId).subscribe((response) => {
            if (response && response.status === 200) {
                this.PATimestamp = response.data['datetime'] ? moment(response.data['datetime']).format("MM/DD/YYYY HH:mm:ss") : null;
            }
        });
    }
    showResults() {
        // show petition analysis
        let domainName = window.location.host;
        if (sessionStorage.getItem('userTypeRole') === 'Petitioner') {
            window.open(`${environment.appUrl}/petitioner-landing/petition-analysis`, '_blank');
        }
        else {
            window.open(`${environment.appUrl}/attorney-landing/petition-analysis`, '_blank');
        }
    }
    userSelected({ value }) {
        this.reviewerInformation.reviewerDesignation = this.users.find(x => x.id === value['id'])['designation'];
    }
    initReviewerDetails() {
        this.apiService.getPetionReviewerDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            this.notifyReviewer = response && response.data['id'] ? false : true;
            if (response && response.data['id']) {
                this.reviewerInformation = this.users.find(x => x['id'] === response.data['id']);
                if (this.reviewerInformation && ((_a = this.reviewerInformation) === null || _a === void 0 ? void 0 : _a.id)) {
                    this.reviewerInformation.reviewerDesignation = response.data['designation'];
                }
            }
            else {
                this.apiService.getTask(this.inputData.visatype, this.inputData.subTaskId)
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    var _a;
                    if (response && response['signatoryDetails']) {
                        this.reviewerInformation = this.users.find(x => x['id'] === response['signatoryDetails']['id']);
                        if (this.reviewerInformation && ((_a = this.reviewerInformation) === null || _a === void 0 ? void 0 : _a.id)) {
                            this.reviewerInformation.reviewerDesignation = this.reviewerInformation['designation'];
                        }
                    }
                });
            }
        });
    }
    saveReviewerDetails() {
        this.apiService.savePetionReviewerDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.reviewerInformation.id)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.toastr.success(response.message, 'Success');
                this.notifyReviewer = false;
                this.printReviewForm.resetForm(this.printReviewForm.value);
            }
        });
    }
    generatePetition(isDraft = true) {
        this.apiService.postReviewPetitiondocDraft(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.data) {
                this.enableViewDraftButton = response.data.isExist;
                this.draftGeneratedDate = response.data.lastModifiedTime;
                this.draftPDFPath = response.data.path;
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    getGenernatedPetition(isDraft = true) {
        this.apiService.getReviewPetitiondocDraft(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, isDraft)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.enableViewDraftButton = response.data.isExist;
                this.draftGeneratedDate = response.data.lastModifiedTime;
                this.draftPDFPath = response.data.path;
            }
        });
    }
    viewPetitionDraft(draftPDFPath) {
        window.open(`${environment.docs}${draftPDFPath.substring(23)}`);
    }
    handleNotifyReviewer() {
        this.apiService.postNotifyReviewer(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    submitReview() {
        const payload = {
            benchMarkActionCode: "",
            endDate: "",
            isAttorneyNotify: 0,
            isBeneficiaryNotify: 0,
            isPetitionerNotify: 0,
            receiptCategory: "",
            receiptDate: "",
            receiptNumber: "",
            receiptType: "",
            responseCode: "",
            responseNote: "",
            reviewCode: this.review.reviewCode,
            reviewNote: this.review.reviewNote,
            startDate: "",
            // statusCode: this.review.reviewCode === 'COMPLETE' ? 'COMPLETE' : 'INPROGRESS',
            statusCode: this.review.reviewCode === 'COMPLETE' ? 'COMPLETE' : 'INPROGRESS',
            stepNote: "",
        };
        let visaType = this.inputData.visatype;
        if (this.inputData.caseType == "I130") {
            visaType = this.inputData.caseType;
        }
        this.apiService.postActionCode(visaType, this.inputData.subTaskId, this.inputData.stepId, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                if (this.review.reviewCode === 'NOT_REVIEWED') {
                    this.toastr.success('Petition review is not started', 'Success');
                }
                if (this.review.reviewCode === 'SEND_BACK') {
                    this.toastr.success('Petition is sent back', 'Success');
                }
                if (this.review.reviewCode === 'COMPLETE') {
                    this.toastr.success('Petition review is completed', 'Success');
                }
                this.printReviewForm.resetForm(this.printReviewForm.value);
                this.store.dispatch(updateStepStatusSuccess({ response: response }));
            }
        });
    }
    get DynamicDialogConfigData() {
        return this.inputData;
    }
    getReviewStatusList() {
        this.apiService.getStatusAndResponse("GENSTEP")
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.reviewStatusList = response['review'];
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseReviewPetitionLibraryService.ɵfac = function BaseReviewPetitionLibraryService_Factory(t) { return new (t || BaseReviewPetitionLibraryService)(i0.ɵɵinject(i1$1.AuthenticationService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(APIReviewPetition), i0.ɵɵinject(i4.ToastrService), i0.ɵɵinject(i5.StepStatusUpdatePayloadService), i0.ɵɵinject(i6.DirtyFormGuard), i0.ɵɵinject(i7.DialogService), i0.ɵɵinject(i8.AppServicesLibraryService)); };
BaseReviewPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseReviewPetitionLibraryService, factory: BaseReviewPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseReviewPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.AuthenticationService }, { type: i2.Store }, { type: APIReviewPetition }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.DialogService }, { type: i8.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-review-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIReviewPetition, BaseReviewPetitionLibraryService };
//# sourceMappingURL=base-review-petition-library.js.map
